import Vue from "vue";
import VueRouter from "vue-router";
import { routes } from "./routes.js";
import auth from "../auth";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (
    to.matched.some((record) => record.meta?.requiresAuth) &&
    !auth.isLoggedIn()
  ) {
    auth.logout();
    next({ path: "/", query: { returnUrl: to.fullPath } });
  } else {
    document.title = to.meta.title;
    next();
  }
});

export default router;
